export default function fetchProgramacaoGenerica(){

    const listDatas = document.querySelectorAll('.lista-datas-js');
    const programacoesWrapper = document.querySelector('.conteudo-programacao-js');

    const programacaoExpositores = document.querySelector('.programacao-expositores');
    const programacaoAutografos = document.querySelector('.programacao-autografos');

    const filtrarSearchInput = document.querySelector('.filtrar-por-espaco-input');

    function renderProgramacaoExpositores(data){
        if(!data) return
        
        const resultadosOrdenados = data.results.sort((a, b) => a.horario.localeCompare(b.horario));
   
        const programacaoHTML = resultadosOrdenados.map(item => {
            const {id, expositor, descricao, espaco, tipo_sessao, descricao_editora, participante, acoes, classificao_etaria, publico_estimado,
                data, horario,status
            } = item
            return `
             <div class="card-programacao-expositor">
                    <div class="flex-between">

                        <h2 class="title one-line" >${expositor}</h2>
                        <div class="card-expositor-horario">
                            <svg style="width: 20px; height: 20px;">
                                <use xlink:href="#icon-horario"></use>
                            </svg>
                            <span> às ${horario?.split(':').slice(0, 2).join(':')}</span>
                        </div>
                    </div>
                    <div class="grid-cards-expositores">
                        <div class="card-base">
                            <p class="label">espaço</p>

                            <h3 class="descricao">
                                ${espaco ? espaco : '-'}
                            </h3>
                        </div>
                        <div class="card-base">
                            <p class="label">sessão</p>

                            <h3 class="descricao">
                                ${tipo_sessao ? tipo_sessao : '-'}
                            </h3>
                        </div>
                        <div class="card-base">
                            <p class="label">autor/participante</p>

                            <h3 class="descricao">
                                ${participante ? participante : '-'}
                            </h3>
                        </div>
                        ${ descricao ? `
                            <div class="card-base" style="grid-column: 1 / -1;">
                                <p class="label">descrição</p>

                                <h3 class="descricao">
                                    ${descricao}
                                </h3>
                            </div>
                            ` : ''}
                          
                    </div>
                </div>
            `;
        }).join('')

        if(programacoesWrapper){
       
            if(programacaoHTML){

                programacoesWrapper.innerHTML = programacaoHTML;
            }else{
                programacoesWrapper.innerHTML = `
                <p style="font-size: 18px; ">
                    Nenhum Expositor encontrado para essa data
                </p>`
            }
          }
    }

    function renderProgramacaoAutografos(data){
        if(!data) return 

        const resultadosOrdenados = data.results.sort((a, b) => a.horario.localeCompare(b.horario));

        const programacaoHTML = resultadosOrdenados.map(item => {
            const {id, atracao,espaco,horario,imagem,ordem,quantidade_autografo
            } = item


            return `
             <div class="card-programacao-expositor">
                <div class="flex-autografos">
                    <div class="col-1">
                        <div class="card-evento-img">
                                ${imagem ? `<img src='${imagem}' alt="">` : `<img src='http://placehold.co/280x280.png' alt="">`}
                            
                        </div>
                    </div>
                


                    <div class="col-2">
                    <div class="flex-between">

                        <h2 class="title one-line" > ${atracao} </h2>
                        <div class="card-expositor-horario">
                            <svg style="width: 20px; height: 20px;">
                                <use xlink:href="#icon-horario"></use>
                            </svg>
                            <span> às ${horario?.split(':').slice(0, 2).join(':')}</span>
                        </div>
                    </div>
                    <div class="">
                        <div class="card-base">
                            <p class="label">local</p>

                            <h3 class="descricao">
                                ${espaco ? espaco : '-'}
                            </h3>
                        </div>
                       
                        
                    </div>
                    </div>
                </div>
            </div>
            `;
        }).join('')

        if(programacoesWrapper){
       
            if(programacaoHTML){

                programacoesWrapper.innerHTML = programacaoHTML;
            }else{
                programacoesWrapper.innerHTML = `
                <p style="font-size: 18px; ">
                    Nenhum Autor encontrado para essa data
                </p>`
            }
          }
    }


    function getProgramacao(data, search= ''){
          if(!data) return
        

          const urlApi = programacaoExpositores ? 'expositores-programacao' : programacaoAutografos ? 'programacao-autografo' : '';
        
          if(!urlApi) return
           const  url = `/api/${urlApi}/?data=${data}&search=${search}`
        
          axios.get(url)
              .then((response) => {

                if(response.data){
                    

                    if(programacaoExpositores){
                        renderProgramacaoExpositores(response.data);
                    }else if(programacaoAutografos){
                        renderProgramacaoAutografos(response.data);
                    }
                    console.log('response', response.data)
                    // if(inHome){
                    //   renderProgramacaoInHome(response.data);
                    // }else{
                    //   renderProgramacao(response.data)
                    // }
                }
              })
              .catch((response) => {
                  console.log('error', response)
                  
              });
    }

    
    listDatas && listDatas.forEach(data => {
        data.addEventListener('click', (e) => {
            const target = e.target.closest('.lista-datas-js')
            if(!target) return
          
            listDatas.forEach(i => i.classList.remove('active'))
            target.classList.add('active')
            const data = target.dataset.diaEvento

            const inputPesquisa = document.querySelector('.input-pesquisa')
            // const espaco = selectLabel.dataset.espacoSelecionado
            const novaURL = `${window.location.origin}${window.location.pathname}?search=${inputPesquisa?.value ? inputPesquisa.value : ''}&data=${data}`;

            // if (pageProgramacaoInfantil){
            //     console.log('url infantil', urlInfantil);
            //     window.history.pushState({}, '', urlInfantil); 
            //     getProgramacao(data , espaco);
            // } else if (!pageProgramacaoInfantil){
            window.history.pushState({}, '', novaURL); 
            getProgramacao(data ,inputPesquisa?.value ? inputPesquisa.value : '');
        })
    })

    function formSearch(){
        if(!filtrarSearchInput) return
        filtrarSearchInput.addEventListener('submit', (e) => {
            e.preventDefault()
            const inputPesquisa = document.querySelector('.input-pesquisa')

            if(inputPesquisa){
             
                    const search = inputPesquisa.value
                    const data = document.querySelector('.lista-datas-js.active')?.dataset.diaEvento
                    getProgramacao(data, search)
             
            }
        })
    }

    function init(){
        const urlParams = new URLSearchParams(window.location.search);
        const data = urlParams.get('data');
        const search = urlParams.get('search');
        const inputPesquisa = document.querySelector('.input-pesquisa')


        formSearch()
       


        if(data){
            listDatas.forEach(i => i.classList.remove('active'))
            const dataAtiva = document.querySelector(`.lista-datas-js[data-dia-evento="${data}"]`)
            dataAtiva && dataAtiva.classList.add('active')
            getProgramacao(data, search ? search : inputPesquisa?.value ? inputPesquisa.value : '');
        }else{
            getProgramacao(listDatas[0]?.dataset.diaEvento, search ? search : inputPesquisa?.value ? inputPesquisa.value : '');
        }
    }
    init()
}